"use strict";
angular.module("imagetrend.components").directive("hlpList", ["$filter", "Format", "$state", "Cache", "$window", "$timeout", "$rootScope", "$injector", "$q", "$uibModal", function ($filter, Format, $state, Cache, $window, $timeout, $rootScope, $injector, $q, $uibModal) {
    return {
        restrict: "E",
        transclude: true,
        replace: true,
        scope: {
            //attributes 
            name: "@?",
            id: "@?",
            classes: "@?",
            cacheListAttrs: "@?",
            defaultSort: "@?",
            defaultSortOrder: "@?",
            //scope 
            showPagination: "@?",
            showAlpha: "@?",
            alphaField: "@?",
            showSearch: "@?",
            defaultNumPerPage: "@?",
            //default numPerPage listParam value on page load
            records: "=?",
            columns: "=?",
            filters: "=?",
            advancedFilters: "=?",
            link: "=?",
            clickable: "=?",
            bulkActions: "=?",
            recordsLoading: "=?",
            listLoading: "=?",
            showBulkAction: "@?",
            bulkActionItems: "=?",
            bulkActionRunning: "=?",
            linkDisabled: "=?",
            hidePdf: "=?",
            service: "@?",
            criteria: "=?",
            stopPropagation: "@?",
            refresh: "=?",
            displayAlerts: "=?",
            // sub list params
            subList: "@?",
            subRecords: "=?",
            subColumns: "=?",
            pdfLinkDisabled: "=?"

        },
        controller: ["$scope", function ($scope) {
            this.alphaFilterChanged = function (letter) {
                $scope.listParams.alphaFilter = letter;
                $scope.masterFilter();
            };
            this.pageChanged = function (page) {
                $scope.listParams.currentPage = page;
                $scope.masterFilter();
            };
            this.perPageChanged = function (perPage) {
                $scope.listParams.numPerPage = perPage;
                $scope.listParams.currentPage = 0;
                $scope.masterFilter();
            };
            this.filterChanged = function (keep) {
                $scope.masterFilter(keep);
            };
            $scope.openMonitoringModal = function (record, $event) {
                // Prevent row click from firing
                if ($event) {
                    $event.stopPropagation();
                    $event.preventDefault();
                }

                $uibModal.open({
                    animation: true,
                    templateUrl: paths.app + 'investigations/components/investigation-monitoring-modal/investigation-monitoring-modal.html',
                    controller: 'InternalInvestigationMonitoringModal',
                    size: 'lg',
                    backdrop: 'static',
                    ariaLabelledBy: 'monitoring-modal-header',
                    resolve: {
                        monitoringEntries: function () {
                            return record.monitoring_entries;
                        }
                    }
                });
            };
        }],
        templateUrl: "templates/list/list.html",
        link: function (scope, elem, attrs, ctrl) {
            scope.advancedFilterOn = false;
            scope.sortBy = null;
            scope.loading = true;
            scope.vm = {
                isApplyAll: false
            };
            var timeouts = [];
            var filtered = false;
            var recordsSet = false;
            var numOfSortOrderCols = 0;
            if (!attrs.name) {
                attrs.name = "list";
            }
            if (!attrs.id) {
                attrs.id = attrs.name;
            }
            if (attrs.showAlpha == undefined) {
                attrs.showAlpha = true;
            } else {
                attrs.showAlpha = attrs.showAlpha == "true";
            }
            if (attrs.showBulkAction == undefined) {
                attrs.showBulkAction = false;
            } else {
                attrs.showBulkAction = attrs.showBulkAction == "true";
            }
            if (attrs.showPagination == undefined) {
                attrs.showPagination = true;
            } else {
                attrs.showPagination = attrs.showPagination == "true";
            }
            if (attrs.showSearch == undefined) {
                attrs.showSearch = true;
            } else {
                attrs.showSearch = attrs.showSearch == "true";
            }
            if (attrs.cacheListAttrs == undefined) {
                attrs.cacheListAttrs = true;
            } else {
                attrs.cacheListAttrs = attrs.cacheListAttrs == "true";
            }
            if (attrs.alphaField == undefined) {
                attrs.alphaField = "name";
            }
            if (attrs.stopPropagation == undefined) {
                attrs.stopPropagation = false;
            } else {
                attrs.stopPropagation = attrs.stopPropagation == "true";
            }
            if (attrs.refresh != null && attrs.refresh != undefined) {
                scope.refresh = attrs.refresh;
            };
            scope.listParams = {
                currentPage: 0,
                numPerPage: attrs.showPagination ? 10 : null,
                alphaFilter: null,
                search: {
                    value: "",
                    type: "input"
                },
                sortBy: null,
                reverse: false
            };
            if (attrs.sublist != null) {
                scope.subList = attrs.sublist == "true";
            };
            if (attrs.subcolumns != null) {
                scope.subColumns = attrs.subcolumns;
            };
            if (attrs.subrecords != null) {
                scope.subRecords = attrs.subrecords;
            };
            
            if (attrs.defaultSort != null) {
                scope.listParams.sortBy = attrs.defaultSort;
            }
            if (attrs.defaultNumPerPage != null) {
                scope.listParams.numPerPage = parseInt(attrs.defaultNumPerPage, 10);
            }
            scope.internalURL = $rootScope.internalURL;
            if ($rootScope.isPortal && $rootScope.isPortal == "True") {
                scope.documentURL = $rootScope.portalURL;
            }
            else {
                scope.documentURL = $rootScope.internalURL;
            }
            scope.recordsTotal = null;
            scope.dynamic = false;
            scope.pageRecords = {};
            var searchTimeout = null;
            var service = null;
            scope.getRecords = function () {
                if (scope.dynamic && service != null) {
                    if (scope.filteredRecords == null) {
                        scope.filteredRecords = [];
                    }
                    if (scope.pageRecords[scope.listParams.currentPage] == null) {
                        scope.loading = true;
                        if (searchTimeout != null) {
                            searchTimeout.resolve();
                            searchTimeout = null;
                        }
                        searchTimeout = $q.defer();
                        service["getFilter"]({
                            currentPage: scope.listParams.currentPage,
                            numPerPage: scope.listParams.numPerPage,
                            sortBy: scope.sortBy,
                            search: scope.listParams.search.value,
                            reverse: scope.reverse,
                            alphaFilter: scope.listParams.alphaFilter,
                            filters: scope.filters,
                            advancedFilters: scope.advancedFilters,
                            criteria: scope.criteria
                        }, searchTimeout).then(function (data) {
                            searchTimeout = null;
                            if (data != null) {
                                scope.pageRecords[scope.listParams.currentPage] = data;
                                scope.filteredRecords = data;
                                scope.loading = false;
                            }
                        });
                    } else {
                        scope.filteredRecords = scope.pageRecords[scope.listParams.currentPage];
                    }
                }
            };
            var countTimeout = null;
            scope.getCount = function () {
                if (scope.dynamic && service != null) {
                    if (countTimeout != null) {
                        countTimeout.resolve();
                        countTimeout = null;
                    }
                    countTimeout = $q.defer();
                    service["getCount"]({
                        search: scope.listParams.search.value,
                        alphaFilter: scope.listParams.alphaFilter,
                        filters: scope.filters,
                        advancedFilters: scope.advancedFilters,
                        criteria: scope.criteria
                    }, countTimeout).then(function (data) {
                        scope.recordsTotal = data;
                    });
                }
            };
            if (attrs.service != null && attrs.service != "") {
                scope.dynamic = true;
                var service = $injector.get(attrs.service);
                timeouts.push($timeout(function () {
                    scope.getCount();
                    scope.getRecords();
                    scope.$watch("criteria", function (criteria, oldCriteria) {
                        if (criteria != null && criteria != oldCriteria) {
                            ctrl.filterChanged();
                        }
                    }, true);
                }, 400));
            }

            scope.evaluateField = function (record, field, type, showDashes, revertTimeZone, dateTimeFlag) {
                var value = "";
                if (type == "empty") {
                    return value;
                }
                //can set json to be comma list to show more values.all depend on each other(ie: if one is null all becomes '')
                var i = 0;
                var broke = false;
                field.split(",").forEach(function (f) {
                    if (!broke) {
                        var v = "";
                        if (f.indexOf("'") >= 0) {
                            v = f.replace(/['"]+/g, "");
                        } else {
                            // If record is a vehicle without a revertTimeZone flag, set it to true & Vehicle primary certification issue/expiration date translate correctly
                            if (record.vehicles_serial_number !== undefined && revertTimeZone === undefined) revertTimeZone = true;

                            v = Format.evaluateJSON(record, f, revertTimeZone);
                            if (angular.isArray(v)) {
                                var arrayValue = "";
                                v.forEach(function (obj) {
                                    if (typeof obj != "object") {
                                        if (arrayValue == "" && value == "") {
                                            arrayValue += obj;
                                        } else {
                                            arrayValue += ", " + obj;
                                        }
                                    } else {
                                        if (arrayValue == "" && value == "") {
                                            if (isValidDate(obj.name)) {
                                                arrayValue = $filter("date")(obj.name, "MM/dd/yyyy");
                                            } else if (obj.fullName != null) {
                                                arrayValue += obj.fullName; // if its a list of name objects
                                            } else {
                                                arrayValue += obj.name;
                                            }
                                        } else {
                                            if (isValidDate(obj.name)) {
                                                arrayValue += ", " + $filter("date")(obj.name, "MM/dd/yyyy");
                                            } else if (obj.fullName != null) {
                                                arrayValue += ", " + obj.fullName;
                                            } else {
                                                arrayValue += ", " + obj.name; // if its a list of name objects
                                            }
                                        }
                                    }
                                });
                                v = arrayValue;
                            } else if (f == "users" || f == "vehicles" || f == "services") {
                                v = "";
                            }
                        }
                        if (v != null && typeof v != "object") {
                            if (i > 0 && value != "") {
                                value += " ";
                            }
                            value += v;
                        } else {
                            if (typeof v == "object") {
                                value = v;
                            } else {
                                value = "";
                            }
                            broke = true;
                        }
                    }
                    i++;
                });
                if (type == "money") {
                    value = $filter("currency")(value);
                } else if (type == "date") {
                    value = $filter("date")(value, "MM/dd/yyyy");
                } else if (type == "datetime") {
                    if (dateTimeFlag) {
                        var optionalTime = scope.evaluateField(record, dateTimeFlag, "boolean");
                        if (optionalTime) {
                            value = $filter("date")(value, "MM/dd/yyyy hh:mm a");
                        }
                        else {
                            value = $filter("date")(value, "MM/dd/yyyy");
                        }
                    }
                    else {
                        value = $filter("date")(value, "MM/dd/yyyy hh:mm a");
                    }
                } else if (type == "deficiency_total") {
                    if (value == "0") {
                        value = "";
                    }
                } else if (type == "boolean") {
                    value = value === "true";
                } else if (type == "entity") {
                    if (value == "service") {
                        value = $rootScope.enterprise.serviceLabels["SERVICE"];
                    } else if (value == "vehicle") {
                        value = $rootScope.enterprise.vehicleLabels["VEHICLE"];
                    }
                } else if (type == "active") {
                    if (value === "true") {
                        value = "Active";
                    } else {
                        value = "Inactive";
                    }
                } else if (type == "yesno") {
                    if (value === "true") {
                        value = "Yes";
                    } else {
                        value = "No";
                    }
                } else if (type == "passfail") {
                    if (value === "true") {
                        value = "Pass";
                    } else if (value === "false") {
                        value = "Fail";
                    } else {
                        value = "";
                    }
                } else if (type == "environment") {
                    if (value === "true") {
                        value = "Public";
                    } else {
                        value = "Internal";
                    }
                } else if (type == "ckeditor") {
                    // Encode <> tags (prevent XSS), but leave <br> (for display)
                    if (value != null && typeof value === 'string' && (value.includes('<') || value.includes('>'))) {
                        var dirtyVal = value;
                        var dirtyArr = dirtyVal.split(/<br\s*\/?>/gi);
                        var cleanArr = [];
                        angular.forEach(dirtyArr, function (dirtyStr) {
                            dirtyStr = dirtyStr.replace(/</g, '&lt;').replace(/>/g, '&gt;');
                            cleanArr.push(dirtyStr);
                        });

                        value = cleanArr.join('<br>');
                    }
                } else if (type == "file_size") {
                    value = Format.fileSize(value);
                } else if (type == "document") {
                    if (record.investigation_external_document_name === null || record.investigation_external_document_name === '') {
                        if (record.investigation_external_document_file_name !== null) {
                            value = record.investigation_external_document_file_name;
                        } else {
                            value = null;
                        }
                    }
                    else
                    {
                        value = record.investigation_external_document_name;
                    }
                }
                if ((value == "" || value == null) && showDashes != null && showDashes) {
                    value = "--------";
                }
                return value;
            };
            scope.determineClasses = function (index, length, column, record) {
                var classes = "";
                if (column.type == "sort_order" || column.type == "deficiency_total") {
                    classes = "small-cell";
                } else {
                    var value = Math.floor(12 / (length - numOfSortOrderCols));
                    var mod = 12 % (length - numOfSortOrderCols);
                    if (index < mod) {
                        value += 1;
                    }
                    classes = "col-xs-" + value;
                }
                if (column.classes != null && record != null) {
                    column.classes.forEach(function (c) {
                        if (c.compare != null && c.compare) {
                            if (scope.evaluateField(record, c.field, "boolean")) {
                                classes += " " + c.name;
                            }
                        } else {
                            if (record.id == c.field) {
                                classes += " " + c.name;
                            }
                        }
                    });
                }
                return classes;
            };
            scope.getInfoFields = function (record, column) {
                var string = "";
                if (column.info != null && record != null) {
                    column.info.forEach(function (i) {
                        var value = scope.evaluateField(record, i.field);
                        if (value != null && value != "") {
                            if (string != "") {
                                string += " -- ";
                            }
                            string += i.label + ": " + value;
                        }
                    });
                }
                return string;
            };
            scope.sort = function (column) {
                scope.sortBy = column.split(",").shift();
                scope.reverse = !scope.reverse;
                ctrl.filterChanged();
            };
            scope.clear = function () {
                if (scope.filters != null) {
                    scope.filters.forEach(function (filter) {
                        filter.value = null;
                    });
                }
                if (scope.advancedFilters != null) {
                    scope.advancedFilters.forEach(function (advancedFilter) {
                        advancedFilter.value = null;
                    });
                }
                scope.listParams.search.value = "";
                scope.listParams.alphaFilter = null;
                ctrl.filterChanged();
            };
            scope.advancedFilter = function () {
                if (scope.advancedFilterOn == true) {
                    if (scope.advancedFilters != null) {
                        scope.advancedFilters.forEach(function (advancedFilter) {
                            advancedFilter.value = null;
                        });
                        ctrl.filterChanged();
                    }
                    scope.advancedFilterOn = false;
                } else {
                    scope.advancedFilterOn = true;
                }
            };
            scope.changeState = function (link, record) {
                if (link != null) {
                    var params = {};
                    for (var i in link.params) {
                        params[link.params[i].name] = scope.evaluateField(record, link.params[i].field);
                    }
                    $state.go(link.state, params);
                }
            };
            scope.dropDown = function (record) {
                if (record.open == true) {
                    record.open = false;
                } else {
                    record.open = true;
                }
            };

            scope.openDocument = function (id, code, url) {
                if (url == null || url === "") {
                    return;
                }
                var separator = url.indexOf("?") === -1 ? "?" : "&";
                var documentId = encodeURIComponent(String(id).toUpperCase());
                var documentCode = encodeURIComponent(code == null ? "" : code);
                $window.open(url + separator + "documentID=" + documentId + "&code=" + documentCode, "_blank");
            };
            scope.htmlLink = function (link, record) {
                if (link != null) {
                    var params = {};
                    for (var i in link.params) {
                        params[link.params[i].name] = scope.evaluateField(record, link.params[i].field);
                    }
                    return $state.href(link.state, params);
                }
                //use the current location 
                return $window.location.href;
            };
            scope.checkPermission = function (permission, record) {
                var hasPermission = false;
                if (permission != null) {
                    var document_type_id = scope.evaluateField(record, permission.field);
                    if (document_type_id == null) {
                        hasPermission = true;
                    } else {
                        if (permission != null) {
                            permission.types.forEach(function (type) {
                                if (type.id == document_type_id) {
                                    hasPermission = true;
                                }
                            });
                        }
                    }
                } else {
                    hasPermission = true;
                }
                return hasPermission;
            };
            scope.applyAll = function (records, isApplyAll) {
                if (scope.bulkActionItems == null) {
                    scope.bulkActionItems = [];
                } else {
                    scope.bulkActionItems.length = 0;
                }
                records.forEach(function (record) {
                    if (!record.skipBulkAction) {
                        record.inBulkApply = isApplyAll;
                        if (isApplyAll) {
                            scope.bulkActionItems.push(record.id);
                        }
                    }
                });
            };
            scope.applyOne = function (record) {
                if (scope.bulkActionItems == null) {
                    scope.bulkActionItems = [];
                }
                if (record.inBulkApply) {
                    scope.bulkActionItems.push(record.id);
                } else {
                    var index = scope.bulkActionItems.indexOf(record.id);
                    scope.bulkActionItems.splice(index, 1);
                }
            };
            scope.initBulkAction = function (bulkAction) {
                if (bulkAction.options == null && bulkAction.service != null && bulkAction.service != "") {
                    var service = $injector.get(bulkAction.service);
                    service[bulkAction.method == null ? "get" : bulkAction.method]().then(function (data) {
                        bulkAction.options = data;
                    });
                }
            };
            scope.showActionForRecord = function (column, record) {
                var show = true;
                if (column.hideAction != null) {
                    show = !scope.evaluateField(record, column.hideAction, "boolean");
                }
                else if (column.hideActionPermission != null) {
                    show = scope.checkPermission(column.hideActionPermission, record);
                }
                if (!show) {
                    record.skipBulkAction = true;
                } else {
                    record.skipBulkAction = false;
                }
                return show;
            };
            scope.masterFilter = function (keep) {
                if (scope.dynamic) {
                    if (!keep) {
                        scope.pageRecords = {};
                        scope.getCount();
                    }
                    scope.getRecords();
                } else {
                    if (scope.records != null) {
                        if (scope.filters != null && scope.advancedFilters != null) {
                            var filteredOut = $filter("listFilter")(scope.records, scope.filters.concat(scope.advancedFilters));
                        }
                        else if (scope.filters != null && scope.advancedFilters == null) {
                            var filteredOut = $filter("listFilter")(scope.records, scope.filters);
                        }
                        else if (scope.filters == null && scope.advancedFilters != null) {
                            var filteredOut = $filter("listFilter")(scope.records, scope.advancedFilters);
                        }
                        else {
                            var filteredOut = scope.records;
                        }
                        var reverseDefaultSort = false;
                        if (scope.defaultSort != null) {
                            if (scope.defaultSortOrder == 'desc') { reverseDefaultSort = true; }
                            filteredOut = $filter("orderBy")(filteredOut, scope.defaultSort, reverseDefaultSort);
                        }
                        filteredOut = $filter("orderBy")($filter("filter")($filter("firstLetter")(filteredOut, scope.alphaField, scope.listParams.alphaFilter), scope.listParams.search.value), [scope.sortBy == null ? "1" : scope.sortBy, scope.sortBy], scope.reverse);
                        scope.recordsTotal = filteredOut.length;
                        scope.filteredRecords = $filter("limitTo")($filter("startFrom")(filteredOut, scope.listParams.currentPage * scope.listParams.numPerPage), scope.listParams.numPerPage);
                        scope.loading = false;
                    }
                }
                scope.cacheList();
            };
            scope.cacheList = function () {
                timeouts.push($timeout(function () {
                    if (!scope.recordsLoading && attrs.cacheListAttrs) {
                        var data = {
                            filters: scope.filters,
                            advancedFilters: scope.advancedFilters,
                            sortBy: scope.sortBy,
                            reverse: scope.reverse,
                            search: scope.listParams.search,
                            alphaFilter: scope.listParams.alphaFilter,
                            numPerPage: scope.listParams.numPerPage,
                            currentPage: scope.listParams.currentPage
                        };
                        Cache.setState("list", data);
                    }
                }, 300));
            };
            scope.isTotalUndefined = function (str) {
                return isUndefined(str) || str == "0";
            };
            scope.setCachedFilters = function (filters, cachedFilters) {
                filters.forEach(function (f) {
                    if (!f.checkedCache) {
                        cachedFilters.forEach(function (of) {
                            if (f.field == of.field && of.value != undefined) {
                                f.value = of.value;
                            }
                        });
                        f.checkedCache = true;
                    }
                });
            };
            scope.$watch("filters", function (filters, oldFilters) {
                if (filters != null) {
                    if (scope.cachedFilters != null) {
                        scope.setCachedFilters(filters, scope.cachedFilters);
                    }
                    timeouts.push($timeout(function () {
                        if (scope.records != null && !filtered && recordsSet) {
                            ctrl.filterChanged();
                            filtered = true;
                        }
                    }, 0));
                }
            }, true);
            scope.$watch("records", function (records, oldRecords) {
                timeouts.push($timeout(function () {
                    if (records != null) {
                        filtered = false;
                        ctrl.filterChanged();
                        filtered = true;
                        recordsSet = true;
                        scope.loading = false;
                    }
                }, 400));
            }, true);
            scope.$watch("columns", function (columns, oldColumns) {
                if (columns != null) {
                    numOfSortOrderCols = 0;
                    columns.forEach(function (column) {
                        if (column.type == "sort_order" || column.type == "deficiency_total") {
                            numOfSortOrderCols++;
                        }
                    });
                }
            }, true);
            var cacheLoading = false;
            scope.$watch("listParams.search.value + listParams.alphaFilter", function (old, newie) {
                if (old != newie && !cacheLoading) {
                    scope.listParams.currentPage = 0;
                    ctrl.filterChanged();
                }
            });
            scope.$watch("sortBy + reverse + listParams.numPerPage", function (old, newie) {
                if (old != newie && !cacheLoading) {
                    ctrl.filterChanged();
                }
            });
            scope.$watch("listParams.currentPage", function (old, newie) {
                if (old != newie && !cacheLoading) {
                    ctrl.filterChanged(true);
                }
            });
            scope.$watch("refresh", function (oldValue, newValue) {
                if (oldValue != newValue && !cacheLoading) {
                    ctrl.filterChanged();
                }
            });
            scope.$watch('defaultNumPerPage', function (newVal, oldVal) {
                // Hit onload / change of view
                if (newVal !== oldVal) {
                    scope.listParams.numPerPage = parseInt(newVal, 10);
                    scope.listParams.currentPage = 0; // Resets to first page on change of Internal View
                    ctrl.filterChanged(true);
                    ctrl.pageChanged();
                }
            });
            if (attrs.cacheListAttrs) {
                cacheLoading = true;
                Cache.getState("list").then(function (state) {
                    if (state != undefined) {
                        scope.sortBy = state.sortBy;
                        scope.reverse = state.reverse;
                        scope.listParams.search = state.search;
                        if (!scope.listParams.search || scope.listParams.search == "") {
                            scope.listParams.search = {};
                            scope.listParams.search.type = "input";
                        }
                        scope.listParams.alphaFilter = state.alphaFilter;
                        scope.listParams.numPerPage = state.numPerPage;
                        scope.listParams.currentPage = state.currentPage;
                        scope.cachedAdvancedFilters = state.advancedFilters;
                        scope.cachedFilters = state.filters;
                        if (scope.cachedFilters != null && scope.filters != null) {
                            scope.setCachedFilters(scope.filters, scope.cachedFilters);
                        }
                        timeouts.push($timeout(function () {
                            cacheLoading = false;
                        }, 50));
                    }
                }).catch(function (response) {
                    return $q.reject(response.data);
                });
            }
            scope.$on("$destroy", function () {
                timeouts.forEach(function (timeout) {
                    $timeout.cancel(timeout);
                });
                if (elem) {
                    angular.element(elem).off();
                    angular.element(elem).remove();
                    elem = null;
                }
            });
        }
    };
}]).filter("listFilter", ["$filter", function ($filter) {
    return function (records, filters) {
        var filtered = records;
        if (filtered != null) {
            for (var i in filters) {
                if (filters[i].value != null && (typeof filters[i].value === "boolean" || typeof filters[i].value === "number" || filters[i].value != "")) {
                    if (filters[i].field != null && filters[i].field != "") {
                        if (filters[i].type != null && filters[i].type == "days") {
                            filtered = $filter("days")(filtered, filters[i].value, filters[i].field);
                        }
                        else if (filters[i].value != null && filters[i].type == "DateStart") {
                            var opts = filtered;
                            filtered = [];
                            for (var x in opts) {
                                opts[x][filters[i].field].setHours(0); opts[x][filters[i].field].setMinutes(0);
                                if (opts[x][filters[i].field] >= filters[i].value) {
                                    filtered.push(opts[x]);
                                }
                            }
                        }
                        else if (filters[i].value != null && filters[i].type == "DateEnd") {
                            var opts = filtered;
                            filtered = [];
                            for (var x in opts) {
                                opts[x][filters[i].field].setHours(0); opts[x][filters[i].field].setMinutes(0);
                                if (opts[x][filters[i].field] <= filters[i].value) {
                                    filtered.push(opts[x]);
                                }
                            }
                        }
                        else if (filters[i].value !== null && filters[i].type === "ObjectArrayIds") {
                            var opts = filtered;
                            filtered = [];
                            for (var x in opts) {
                                if (opts[x][filters[i].field].some(function (item) { return item.id !== null && item.id.toLowerCase() === filters[i].value.toLowerCase() })) {
                                    filtered.push(opts[x]);
                                }
                            }
                        }
                        else {
                            var field = null;
                            filters[i].field.split(".").reverse().forEach(function (partial) {
                                if (field == null) {
                                    field = {};
                                    field[partial] = filters[i].value;
                                } else {
                                    var parent = {};
                                    parent[partial] = field;
                                    field = angular.copy(parent);
                                }
                            });
                            if (filters[i].contains) {
                                var opts = filtered;
                                filtered = [];
                                for (var x in opts) {
                                    if (opts[x][filters[i].field].includes(filters[i].value)) {
                                        filtered.push(opts[x]);
                                    }
                                }
                            } else {
                                filtered = $filter("filter")(filtered, field);
                            }
                        }
                    } else {
                        filtered = $filter("filter")(filtered, filters[i].value);
                    }
                }
            }
        }
        return filtered;
    };
}]).filter("startFrom", [function () {
    return function (input, start) {
        if (!input) return;
        start = +start;
        return input.slice(start);
    };
}]).filter("firstLetter", ["Format", function (Format) {
    return function (input, field, letter) {
        input = input || [];
        if (field == undefined || letter == undefined) return input;
        var out = [];
        input.forEach(function (item) {
            var value = Format.evaluateJSON(item, field);
            if (value != null && value.charAt(0).toLowerCase() == letter) {
                out.push(item);
            }
        });
        return out;
    };
}]);